var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "tabs-container" }, [
      _c(
        "div",
        { staticClass: "items" },
        _vm._l(_vm.activeItems, function (item, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass: "item",
              class: { active: index === _vm.current },
            },
            [
              _c(
                "div",
                {
                  on: {
                    click: function ($event) {
                      return _vm.goTo(index)
                    },
                  },
                },
                [
                  _vm._v(
                    "\n          " + _vm._s(_vm.$t(item.title)) + "\n        "
                  ),
                ]
              ),
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _vm.items[_vm.current].actions
        ? _c(
            "div",
            { staticClass: "actions" },
            _vm._l(_vm.items[_vm.current].actions, function (action, index) {
              return _c(action, {
                key: index,
                tag: "component",
                staticClass: "action",
                attrs: { event: _vm.event, formOptions: _vm.formOptions },
                model: {
                  value: _vm.extData,
                  callback: function ($$v) {
                    _vm.extData = $$v
                  },
                  expression: "extData",
                },
              })
            }),
            1
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "container" },
      _vm._l(_vm.activeItems, function (item, index) {
        return _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.current === index,
                expression: "current === index",
              },
            ],
            key: index,
          },
          [
            _c(item.comp, {
              ref: index,
              refInFor: true,
              tag: "component",
              attrs: { formOptions: _vm.formOptions, event: _vm.event },
              model: {
                value: _vm.extData,
                callback: function ($$v) {
                  _vm.extData = $$v
                },
                expression: "extData",
              },
            }),
          ],
          1
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }